import React from "react";

interface ListboxProps extends React.HTMLAttributes<HTMLElement> {}

export const Listbox = React.memo(
  React.forwardRef<HTMLUListElement, ListboxProps>((props, ref) => {
    const { children, ...other } = props;
    return (
      <ul ref={ref} {...other}>
        {children}
      </ul>
    );
  })
);
